import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import theme from '../../theme';
import Button from '../../components/button';

interface Props {
  title: string;
  description: string;
  Image: React.FC<any>
  buttonText?: string;
  onClick?: (e: any) => void;
}

const OnboardingEmpty: React.FC<Props> = ({
  title,
  Image,
  description,
  onClick,
  buttonText,
}) => {
  const largerScreen = useMediaQuery('(min-width:1087px)');
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-around"
      sx={{ background: theme.palette.background.paper }}
      border="1px solid #CCCCCC"
      borderRadius="4px"
      minHeight="484px"
      height="fit-content"
      flexWrap="wrap"
      p={5}
    >
      <Image width="100%" />
      <Box
        display="flex"
        flexDirection="column"
        alignItems={largerScreen ? 'start' : 'center'}
        justifyContent={largerScreen ? 'space-around' : 'start'}
        width={largerScreen ? '50%' : '100%'}
      >
        <Typography variant={largerScreen ? 'h1' : 'h4'}>
          {title}
        </Typography>
        <Typography variant="body1" mt={1} sx={{ opacity: 0.5 }}>
          {description}
        </Typography>
        <Button sx={{ mt: 1 }} variant="outlined" onClick={onClick}>
          {buttonText}
        </Button>
      </Box>
    </Box>
  );
};

export default OnboardingEmpty;
